<div class="search-container">
  <div class="input-group">
    <div class="input-with-icon">
      <span class="icon" aria-hidden="true">
        <span class="material-icons-round">{{ icon }}</span>
      </span>
      <input
        type="text"
        class="form-control"
        [id]="inputId"
        [placeholder]="placeholder"
        [attr.aria-label]="label"
        [(ngModel)]="value"
        (input)="onInputChange($event)"
      />

           <button 
        *ngIf="value" 
        type="button" 
        class="clear-btn"
        (click)="clearInput()"
        aria-label="Clear">
        &times;
      </button>
    </div>
  </div>
</div>